import { useQuery } from "@tanstack/react-query";

import { getPatientPharmacies } from "~/patients/api/pharmacies";
import { getTeamMemberPatientPharmacies } from "~/providers/api/patientPharmacies";
import { patientPharmaciesQueryKey } from "./patientPharmaciesQueryKey";

interface UseGetPatientPharmaciesProps {
  patientId?: string;
  enabled?: boolean;
}

export const useGetPatientPharmacies = ({
  patientId,
  enabled = true,
}: UseGetPatientPharmaciesProps = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: patientPharmaciesQueryKey(patientId),
    queryFn: () =>
      patientId
        ? getTeamMemberPatientPharmacies(patientId)
        : getPatientPharmacies(),
    enabled,
  });

  return { data, isLoading };
};
